// extracted by mini-css-extract-plugin
export default {"container":"TextEditProfile_container__gTn8O","label":"TextEditProfile_label__qQc49","input":"TextEditProfile_input__dwaU7","textarea":"TextEditProfile_textarea__FKcGE"};